import store from '@/store/store'
import MainLedgerDetailService from '@/services/MainLedgerDetailService'

// Polja kojima se redak uplate veze na racun (staro povezivanje). Pise ih server pri
// povezivanju (POST /zatvaranja/povezi), pa ih klijentov store ne moze znati.
const POLJA_VEZE = ['invoiceInNumber', 'invoiceOutNumber', 'BusinessYearInvoice']

/**
 * Ako su se veze promijenile otkako je ekran dokumenta zadnji put citao retke,
 * s poslužitelja se ponovno procitaju SAMO polja veze i upisu u retke u storeu.
 *
 * Ostatak redaka se ne dira: korisnik je mozda nesto promijenio, a nije snimio, i to se
 * ne smije izgubiti. Retci koji nemaju id iz baze (novi, nespremljeni) ostaju kakvi jesu.
 *
 * @returns {Promise<boolean>} true ako je store promijenjen (ekran treba iscrtati ponovno)
 */
export async function osvjeziVezeRedaka () {
  if (store.state.vezePromjena === store.state.vezeOsvjezeno) { return false }
  const promjena = store.state.vezePromjena
  const dokument = store.state.mainledgerActiv
  const dokumentId = dokument && dokument.id ? dokument.id : 0
  const stari = store.state.mainledgerItems
  if (!dokumentId || !Array.isArray(stari) || stari.length === 0) {
    store.commit('vezeOsvjezene')
    return false
  }
  try {
    const retci = (await MainLedgerDetailService.index(dokumentId)).data.mainledgerDetails || []
    const poId = {}
    retci.forEach(r => { poId[r.id] = r })
    let promijenjeno = false
    // Ponovno se cita iz storea: dok je zahtjev trajao, korisnik je mogao nesto promijeniti.
    const novi = (store.state.mainledgerItems || []).map(redak => {
      const server = poId[redak.id]
      if (!server) { return redak }
      const izmjena = {}
      POLJA_VEZE.forEach(polje => {
        const vrijednost = server[polje] === undefined ? null : server[polje]
        const staro = redak[polje] === undefined ? null : redak[polje]
        if (vrijednost !== staro) { izmjena[polje] = vrijednost }
      })
      if (Object.keys(izmjena).length === 0) { return redak }
      promijenjeno = true
      return {...redak, ...izmjena}
    })
    if (promijenjeno) { await store.dispatch('setMainLedgerItems', novi) }
    // Ako se u meduvremenu opet nesto povezalo, brojac je veci i sljedeci ekran ce opet citati.
    if (store.state.vezePromjena === promjena) { store.commit('vezeOsvjezene') }
    return promijenjeno
  } catch (err) {
    // veza je na serveru; ekran ce probati opet pri sljedecem otvaranju
    return false
  }
}
